import { RepeatOneSharp } from '@material-ui/icons';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  weighbridge: {
    orderType: '',
    selectedCustomer: {
      balance: {
        $numberDecimal: Number(0)
      }
    },
    orderNumber: '',
    orderExist: false,
    orderSubmitted: false,
    IsOrderSaved: false,
    orderId: '',
    orderNote: '',
    deliveryNote: '',
    referenceNumber: '',
    containerNumber: '',
    selectedVehRegNum: '',
    selectedVehDescription: '',
    transporter: '',
    weighbridgeNotes: {
      orderNote: 'Submit Order'
    },
    final: 0,
    weighItems: [],
    lineItems: [],
    orderLoaded: '',
    newPurchaseOrderCreated: 'none',
    newPurchaseOrderSubmitted: 'none',
    purchaseOrderNumber: '',
    purchaseOrderId: '',
    newSaleOrderCreated: 'none',
    newSaleOrderSubmitted: 'none',
    saleOrderNumber: '',
    saleOrderId: '',
  }
};

/**
 * Create Purchase Order
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const newPurchaseOrder = createAsyncThunk(
  'wbn/PostNewPurchaseOrderTemp',
  async (payload, thunkAPI) => {
    // const { order } = payload;
    try {
      //console.log('[weighbridge - slice][createNewPurchaseOrderTemplate]', payload);
      const response = await axios.post(
        `${apiBaseURL}/api/v1/purchases/new`,
        payload
      );
      return response.data.orderDoc;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


/**
 * Create Sale Order
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const newSaleOrder = createAsyncThunk(
  'wbn/PostNewSaleOrderTemp',
  async (payload, thunkAPI) => {
    // const { order } = payload;
    try {
      //console.log('[weighbridge - slice][createNewPurchaseOrderTemplate]', payload);
      const response = await axios.post(
        `${apiBaseURL}/api/v1/sales/new`,
        payload
      );
      return response.data.orderDoc;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


/**
 * Submit Purchase Order 
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const submitNewPurchaseOrderData = createAsyncThunk(
  "wbn/PostUpdatePurchaseOrder",
    async( payload, thunkAPI ) => {
      const { orderType, order } = payload;
    try {
      console.log('BEFORE ORDER DATA SUBMISSION');
      const response = await axios.post(`${apiBaseURL}/api/v1/${orderType}/`, order);
      console.log('wbn/PostOrderData', response.data);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
)


/**
 * Submit Sale Order 
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const submitNewSaleOrderData = createAsyncThunk(
  "wbn/PostUpdateSaleOrder",
    async( payload, thunkAPI ) => {
      const { orderType, order } = payload;
    try {
      console.log('BEFORE ORDER DATA SUBMISSION');
      const response = await axios.post(`${apiBaseURL}/api/v1/${orderType}/`, order);
      console.log('wbn/PostOrderData', response.data);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
)



/**
 * Submit Order
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
export const submitOrder = createAsyncThunk(
  'wbn/PostOrder',
  async (payload, thunkAPI) => {
    // const { order } = payload;
    try {
      console.log('[wbn/PostOrder]',payload);
      //console.log('[weighbridge - slice][submit order]', payload);
      const response = await axios.post(
        `${apiBaseURL}/api/v1/weighbridges/`,
        payload
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const setEditOrder = createAsyncThunk(
  'wbn/GetOrder',
  async (orderId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${apiBaseURL}/api/v1/weighbridges/${orderId}/`
      );

      const orderData = response.data.orderData;

      const posEdit = {
        locked: orderData.locked,
        selectedCustomer: orderData.customer,
        selectedBranch: orderData.branch,
        orderType: orderData.orderType,
        orderExist: true,
        orderSubmitted: true,
        orderId: orderData._id,
        orderNumber: orderData.WNNumber,
        notes: orderData.notes,
        selectedVehRegNum: orderData.selectedVehRegNum,
        lineItems: orderData.lineItems,
        weighItems: orderData.weighItems,
        setSelectedVehRegNum: orderData.setSelectedVehRegNum,    
        selectedVehDescription: orderData.selectedVehDescription,
        orderNote: orderData.orderNote,
        deliveryNote: orderData.deliveryNote,
        referenceNumber: orderData.referenceNumber,
        containerNumber: orderData.containerNumber,
        transporter: orderData.transporter,
        PONumber: (orderData && orderData.hasOwnProperty('PONumber')) ? orderData.PONumber : '',
        SONumber: (orderData && orderData.hasOwnProperty('SONumber')) ? orderData.SONumber : '',
      };
      return posEdit;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

// /**
//  * Submit Payment
//  * Dispatch Function
//  * @param {object} - payment
//  * @return {object} - success payload
//  */
// export const submitPayment = createAsyncThunk(
//   "pos/PostPayment",
//     async( payload, thunkAPI ) => {
//       try {
//         const response = await axios.post(`${apiBaseURL}/api/v1/transactions/payment/paid`, payload);
//         return response;
//       } catch (err) {
//         return thunkAPI.rejectWithValue(err.response.data);
//       }
//     }
// );
// //TODO: !IMPORTANT - What does it effect???

// export const receivePayment = createAsyncThunk(
//   "pos/PostReceivePayment",
//   async( payload, thunkAPI ) => {
//     try {
//       const response = await axios.post(`${apiBaseURL}/api/v1/transactions/payment/received`, payload);
//       return response;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.response.data);
//     }
//   }
// );

const slice = createSlice({
  name: 'weighbridge',
  initialState,
  reducers: {
    // getSelectedCustomer(state, action) {
    //   const { branches } = action.payload;
    //   // state.branches = branches;
    // },
    setOrderType(state, action) {
      state.weighbridge.orderType = action.payload;
    },
    setSelectedBranch(state, action) {
      state.weighbridge.selectedBranch = action.payload;
    },
    setSelectedUser(state, action) {
      state.weighbridge.selectedUser = action.payload;
    },
    createOrderExist(state, action) {
      state.weighbridge.orderExist = action.payload;
    },
    createOrderId(state, action) {
      state.weighbridge.orderId = action.payload;
    },
    createOrderNumber(state, action) {
      state.weighbridge.orderNumber = action.payload;
    },
    setSelectedCustomer(state, action) {
      state.weighbridge.selectedCustomer = action.payload;
    },
    setOrderNote(state, action) {
      state.weighbridge.orderNote = action.payload;
    },
    setDeliveryNote(state, action) {
      state.weighbridge.deliveryNote = action.payload;
    },
    setReferenceNumber(state, action) {
      state.weighbridge.referenceNumber = action.payload;
    },
    setContainerNumber(state, action) {
      state.weighbridge.containerNumber = action.payload;
    },
    setSelectedVehRegNum(state, action) {
      state.weighbridge.selectedVehRegNum = action.payload;
    },
    setVehDescription(state, action) {
      state.weighbridge.selectedVehDescription = action.payload;
    },
    setTransporter(state, action) {
      state.weighbridge.transporter = action.payload;
    },
    setOrderNoteState(state, action) {
      state.weighbridge.orderNote = action.payload;
    },
    setVat(state, action) {
      state.weighbridge.vat = action.payload;
    },
    setFinal(state, action) {
      state.weighbridge.final = action.payload;
    },
    setPurchaseOrderNumber(state, action) {
      state.weighbridge.purchaseOrderNumber = action.payload;
    },
    setPurchaseOrderId(state, action) {
      state.weighbridge.purchaseOrderId = action.payload;
    },
    setWeighItem(state, action) {
      state.weighbridge.weighItems = [
        ...state.weighbridge.weighItems,
        action.payload
      ];
    },
    updateWeighItem(state, action) {
      // get the id of the item that was updated
      const id = action.payload.id;
      // get the index of the item in the array
      const index = state.weighbridge.weighItems.findIndex(
        weightItem => weightItem.productId === action.payload.productId
      );
      // update the selected item
      state.weighbridge.weightItem[index] = action.payload;
    },
    setLineItem(state, action) {
      state.weighbridge.lineItems = [
        ...state.weighbridge.lineItems,
        action.payload
      ];
    },
    updateLineItem(state, action) {
      // get the id of the item that was updated
      const id = action.payload.id;
      // get the index of the item in the array
      const index = state.weighbridge.lineItems.findIndex(
        item => item.productId === action.payload.productId
      );
      // update the selected item
      state.weighbridge.lineItems[index] = action.payload;
    },
    removeLineItem(state, action) {
      // new items state, exlude the removed item.
      state.weighbridge.lineItems = state.weighbridge.lineItems.filter(
        item => item.productId !== action.payload.productId
      );
    },
    setLineItemTotals(state, action) {
      state.weighbridge.orderTotals = action.payload;
    },
    setPaymentDetails(state, action) {
      state.weighbridge.payment = action.payload;
    },
    // orderSubmitted(state, action) {
    //   state.weighbridge.orderSubmitted = action.payload;
    // },
    setPosOrderStateForPayment(state, action) {
      state.weighbridge = action.payload;
    },
    setPosStateEditOrder(state, action) {
      state.weighbridge = action.payload;
    },
    setIsOrderSaved(state, action) {
      state.weighbridge.IsOrderSaved = action.payload;
    },
    clearOrderData(state, action) {
      return initialState;
    }
  },
  extraReducers: {
    [submitOrder.pending]: (state, action) => {
      state.weighbridge.orderstatus = 'loading';
    },
    [submitOrder.fulfilled]: (state, action) => {
      state.weighbridge.orderstatus = 'saved';
    },
    [submitOrder.rejected]: (state, action) => {
      state.weighbridge.orderstatus = 'failed';
    },
    [setEditOrder.pending]: (state, action) => {
      state.weighbridge.orderLoaded = 'loading';
    },
    [setEditOrder.fulfilled]: (state, action) => {
      state.weighbridge = action.payload;
      state.weighbridge.orderLoaded = 'loaded';
    },
    [setEditOrder.rejected]: (state, action) => {
      state.weighbridge.orderLoaded = 'failed';
    },
    [newPurchaseOrder.pending]: (state, action) => {
      state.weighbridge.newPurchaseOrderCreated = 'loading';
    },
    [newPurchaseOrder.fulfilled]: (state, action) => {
      state.weighbridge.purchaseOrderNumber = action.payload.PONumber;
      state.weighbridge.purchaseOrderId = action.payload._id;
      state.weighbridge.newPurchaseOrderCreated = 'success';
    },
    [newPurchaseOrder.rejected]: (state, action) => {
      state.weighbridge.newPurchaseOrderCreated = 'failed';
    },
    [submitNewPurchaseOrderData.pending]: (state, action) => {
      state.weighbridge.newPurchaseOrderSubmitted = 'loading';
    },
    [submitNewPurchaseOrderData.fulfilled]: (state, action) => {
      state.weighbridge.newPurchaseOrderSubmitted = 'success';
    },
    [submitNewPurchaseOrderData.rejected]: (state, action) => {
      state.weighbridge.newPurchaseOrderSubmitted = 'failed';
    },
    [newSaleOrder.pending]: (state, action) => {
      state.weighbridge.newPurchaseOrderCreated = 'loading';
    },
    [newSaleOrder.fulfilled]: (state, action) => {
      state.weighbridge.saleOrderNumber = action.payload.SONumber;
      state.weighbridge.saleOrderId = action.payload._id;
      state.weighbridge.newSaleOrderCreated = 'success';
    },
    [newSaleOrder.rejected]: (state, action) => {
      state.weighbridge.newPurchaseOrderCreated = 'failed';
    },
    [submitNewSaleOrderData.pending]: (state, action) => {
      state.weighbridge.newSaleOrderSubmitted = 'loading';
    },
    [submitNewSaleOrderData.fulfilled]: (state, action) => {
      state.weighbridge.newSaleOrderSubmitted = 'success';
    },
    [submitNewSaleOrderData.rejected]: (state, action) => {
      state.weighbridge.newSaleOrderSubmitted = 'failed';
    },
  }
});
//newSaleOrder

//  // Add reducers for additional action types here, and handle loading state as needed
//  builder.addCase(submitOrder.fulfilled , (state, action) => {
//   // Add user to the state array
//   state.weighbridge.orderSubmitted.push(action.payload);
// })
// },

export const reducer = slice.reducer;

// export const setIsOrderSaved = orderSubStatus => async dispatch => {
//   dispatch(slice.actions.setIsOrderSaved(orderSubStatus));
// }

export const setOrderType = item => async dispatch => {
  dispatch(slice.actions.setOrderType(item));
};

export const setStateOrderNote = item => async dispatch => {
  dispatch(slice.actions.setOrderNote(item));
};

export const setStateDeliveryNote = item => async dispatch => {
  dispatch(slice.actions.setDeliveryNote(item));
};

export const setStateReferenceNumber = item => async dispatch => {
  dispatch(slice.actions.setReferenceNumber(item));
};

export const setStateContainerNumber = item => async dispatch => {
  dispatch(slice.actions.setContainerNumber(item));
};

export const setStateTransporter = item => async dispatch => {
  dispatch(slice.actions.setTransporter(item));
};

export const setSelectedVehRegNum = vehRegNum => async dispatch => {
  dispatch(slice.actions.setSelectedVehRegNum(vehRegNum));
};

export const setVehDescriptionState = vehDes => async dispatch => {
  dispatch(slice.actions.setVehDescription(vehDes));
};

export const setSelectedCustomer = customer => async dispatch => {
  //if (process.env.REACT_APP_DEVELOPMENT_ENV)
  //console.log('[POS - SLICE] : (setSelectedCustomer)', customer);
  dispatch(slice.actions.setSelectedCustomer(customer));
};

// export const setOrderNoteState = orderNote => async dispatch => {
//   dispatch(slice.actions.setOrderNoteState(orderNote));
// };

// export const setFinalWeight = finalWeight => async dispatch => {
//   dispatch(slice.actions.setFinalWeight(finalWeight));
// };

// Add Remove Products Dialog
export const setLineItem = lineItem => async dispatch => {
  dispatch(slice.actions.setLineItem(lineItem));
};

export const setWeighItem = weighItem => async dispatch => {
  dispatch(slice.actions.setWeighItem(weighItem));
};

export const updateWeighItem = weighItem => async dispatch => {
  dispatch(slice.actions.updateWeighItem(weighItem));
};

export const updateLineItem = lineItem => async dispatch => {
  dispatch(slice.actions.updateLineItem(lineItem));
};

export const setFinal = final => async dispatch => {
  dispatch(slice.actions.setFinal(final));
};

// export const removeLineItem = lineItem => async dispatch => {
//   dispatch(slice.actions.removeLineItem(lineItem));
// };

export const setLineItemTotals = lineItemsTotals => async dispatch => {
  dispatch(slice.actions.setLineItemTotals(lineItemsTotals));
};

export const setSelectedUser = payload => async dispatch => {
  dispatch(slice.actions.setSelectedUser(payload));
};

export const setSelectedBranch = payload => async dispatch => {
  dispatch(slice.actions.setSelectedBranch(payload));
};

// Create Order
export const createOrder = payload => async dispatch => {
  //console.log(`[slice][weigbridge][createOrder]`, payload);

  let response = {};
  try {
    response = await axios.post(
      `${apiBaseURL}/api/v1/weighbridges/new`,
      payload
    );
    //console.log(`[slice][weigbridge][createOrder] - response`, response);
  } catch (error) {
    console.error(error);
  }

  //now we run the dispatch stages
  if (response.data.orderNumber && response.data.orderExist) {
    if (response.data.orderExist === true) {
      dispatch(slice.actions.createOrderNumber(response.data.orderNumber));
      dispatch(slice.actions.createOrderId(response.data.orderDoc._id));
      dispatch(slice.actions.createOrderExist(response.data.orderExist));
    }
  }
  // if (response.data.WNNumber) {
  //   // if (response.data.orderExist === true) {
  //     dispatch(
  //       slice.actions.createOrderNumber(response.data.orderNumber)
  //     );
  //     // dispatch(slice.actions.createOrderId(response.data.orderDoc._id));
  //     // dispatch(slice.actions.createOrderExist(response.data.orderExist));
  //   // }
  // }
};

// export const setPaymentDetails = payload => async dispatch => {
//   dispatch(slice.actions.setPaymentDetails(payload));
// };

export const clearOrderData = () => async dispatch => {
  dispatch(slice.actions.clearOrderData(initialState));
};

// // export const receivePayment = (payload) => async dispatch => {
// //   let response;
// //   try {
// //     response = await axios.post(`${apiBaseURL}/api/v1/transactions/payment/received`, payload);
// //   } catch (error) {
// //     console.error(error);
// //   }
// // }

// export const confirmEft = (payload) => async dispatch => {

//   //console.log('[slice: POS] (confirmEft) - payload', payload);

//   let response;
//   try {
//     response = await axios.post(`${apiBaseURL}/api/v1/transactions/eft/paid`, payload);
//   } catch (error) {
//     console.error(error);
//   }

//   //console.log('[slice: POS] (confirmEft) - response', response);

// }

// export const confirmEftReceived = (payload) => async dispatch => {

//   //console.log('[slice: POS] (confirmEft) - payload', payload);

//   let response;
//   try {
//     response = await axios.post(`${apiBaseURL}/api/v1/transactions/eft/received`, payload);
//   } catch (error) {
//     console.error(error);
//   }

//   //console.log('[slice: POS] (confirmEft) - response', response);

// }

// export const setPosOrderStateForPayment = (orderType, payload) => async dispatch => {

//   //console.log('[slice: POS] (setPosOrderStateForPayment) - payload', payload);

//   const { po_id, user } = payload;

//   let response;
//   try {
//     response = await axios.get(`${apiBaseURL}/api/v1/${orderType}/${po_id}/`, payload);
//   } catch (error) {
//     console.error(error);
//   }

//   // console.log('[slice: POS] (setPosOrderStateForPayment) - response', response);

//   const orderData = response.data.orderData;

//   //console.log('[slice: POS] (setPosOrderStateForPayment) - purchaseOrder', purchaseOrder);

//   let orderNumber;
//   switch (orderType) {
//     case 'sales':
//       orderNumber = orderData.SONumber;
//       break;

//     case 'purchases':
//       orderNumber = orderData.PONumber;
//     break;

//     default:
//       break;
//   }

//   const pos = {
//     selectedCustomer: {
//       balance: {
//         '$numberDecimal': (orderData.customer.balance && orderData.customer.balance.$numberDecimal) ? Number(orderData.customer.balance.$numberDecimal) : 0,
//       },
//       id: orderData.customer.id,
//       _id: orderData.customer._id
//     },
//     selectedBranch: {},
//     selectedUser: {
//       _id: user._id,
//     },
//     products: [],
//     orderExist: true,
//     orderSubmitted: true,
//     orderId: orderData._id,
//     orderNumber,
//     vat: orderData.vat,
//     lineItems: [],
//     orderTotals: {
//       productTotal: Number(orderData.orderTotal.totalInc.$numberDecimal),
//       },
//       payment: {
//         prevCustomerBalance: Number(0),
//         orderTotalPrice: Number(0),
//         cash: Number(0),
//         eft: Number(0),
//         totalPaid: Number(0),
//         allocateToAccount: Number(0),
//         newCustomerBalance: Number(0),
//     }
//   };

//   //console.log('[slice: POS] (setPosOrderStateForPayment) - pos', pos);

//   dispatch(slice.actions.setPosOrderStateForPayment(pos));
// }

// export const setPosStateEditOrder = (orderType, payload) => async dispatch => {

//   const { orderId, user } = payload;

//   let response;
//   try {
//     response = await axios.get(`${apiBaseURL}/api/v1/weighbridges/${orderId}/`);
//   } catch (error) {
//     console.error(error);
//   }

//   //console.log('[slice: POS] (setPosStateEditOrder) - pos', response.data);

//   const orderData = response.data.orderData;

//   console.log('[slice: POS] (setPosStateEditOrder) - orderData (response)', orderData);

//   const posEdit = {
//     locked: orderData.locked,
//     selectedCustomer: orderData.customer,
//     selectedBranch: {
//       _id: orderData.branchId,
//       branchId: orderData.branchId,
//     },
//     selectedUser: {
//       _id: user._id,
//     },
//     orderExist: true,
//     orderSubmitted: true,
//     orderId: orderData._id,
//     orderNumber: orderData.WNNumber,
//     notes: orderData.notes,
//     selectedVehRegNum: orderData.selectedVehRegNum,
//     lineItems: orderData.lineItems,
//     weighItem: orderData.weighItems,
//   }

//   //console.log('[slice: POS] (setPosStateEditOrder) - pos object', posEdit);
//   if (response.status === 200) {
//     dispatch(slice.actions.setPosStateEditOrder(posEdit));
//   }
// }

// export const updateVehRegNum = (payload) => async dispatch => {

// }

// export const removeVehRegNum = (payload) => async dispatch => {

// }

export default slice;
